import React, { useState, useEffect } from 'react';
import { fetchAllSeasons } from '../utilities/api';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Skeleton } from '../components/ui/skeleton';

function SeasonsDropdown({ value, onChange }) {
    const [seasons, setSeasons] = useState([]);
    useEffect(() => {
        const fetchSeasons = async () => {
            try {
                const seasonsData = await fetchAllSeasons();
                setSeasons(seasonsData);
            } catch (error) {
                console.error("Error fetching seasons:", error);
            }
        };
        fetchSeasons();
    }, []);
    return (
        <>
            {seasons.length === 0 ? (
                <Skeleton className="h-[34px] w-[166px] mb-2" />
            ) : (
                <Select onValueChange={onChange} value={value}>
                                    <SelectTrigger name="Seasons">
                    <SelectValue placeholder="All">
                        {value === "All" || !value
                            ? "All"
                            : seasons.find(season => parseInt(season?.id) === parseInt(value))?.attributes?.name || "All"}
                    </SelectValue>
                </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all" className='hover:bg-gold-50' selected>All</SelectItem>
                        {seasons.map(season => (
                            <SelectItem key={season?.id} value={season?.id}>
                                {season?.attributes?.name}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            )}
        </>
    );
}

export default SeasonsDropdown;